import { AppDispatch } from 'redux/store';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'hooks';
import { useCallback } from 'react';
import { notificationQuery } from './notification.selector';
import { notificationActions } from './notification.slice';

export const useNotificationFasade = () => {
  const dispatch: AppDispatch = useDispatch();

  /** Notification一覧 */
  const notifications = useAppSelector(notificationQuery.getNotifications);

  /** 追加(成功) */
  const addSuccessNotification = useCallback(
    (messageId: string, values?: string[]) => dispatch(notificationActions.addSuccess({ messageId, values })),
    [dispatch],
  );
  /** 追加(警告) */
  const addWarningNotification = useCallback(
    (messageId: string, values?: string[]) => dispatch(notificationActions.addWarning({ messageId, values })),
    [dispatch],
  );
  /** 追加(エラー) */
  const addErrorNotification = useCallback(
    (messageId: string, values?: string[]) => dispatch(notificationActions.addError({ messageId, values })),
    [dispatch],
  );
  /** 追加(ファイルダウンロードプログレスバー) */
  const addFileDownloadNotification = useCallback(
    (downloadUrl: string, fileName: string, values: string[]) => dispatch(notificationActions.addFileDownloadNotification({ downloadUrl, fileName, values })),
    [dispatch],
  );
  /** ダウンロード状態変更(ファイルダウンロードプログレスバー) */
  const setFileDownloadFinished = useCallback(
    (notificationId: string) => dispatch(notificationActions.setFileDownloadFinished(notificationId)),
    [dispatch],
  );
  /** 削除 */
  const removeNotification = useCallback(
    (notificationId: string) => dispatch(notificationActions.removeOne(notificationId)),
    [dispatch],
  );

  return {
    notifications,
    addSuccessNotification,
    addWarningNotification,
    addErrorNotification,
    addFileDownloadNotification,
    setFileDownloadFinished,
    removeNotification,
  };
};
